/**
 * Created by - Yogen on 14-06-2025
 * Reason - To display Life Member Details Area wise
 */
import { useEffect, useState, useContext } from "react";
import parse from "html-react-parser";
import style from "./LifeMemberDeatails.module.css";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { getMemberDetailsListAPI } from "../../Api/services";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Modal } from "antd";

const LifeMemberDetails = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();
  // Added by - Yogen  on 12-06-2025
  // Reason - useLocation Used for displaying ward name from member page
  const { id, ward_name } = location?.state || "";
  // End of code - Yogen on 12-06-2025
  // Reason - useLocation Used for displaying ward name from member page
  const [memberDetails, setMemberDetails] = useState([]);
  const [lifeMemberDetails, setLifeMemberDetails] = useState([]);
  // Added by - Ashlekh on 26-04-2025
  // Reason - useState used for antd modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  // End of code - Ashlekh on 26-04-2025
  // Reason - useState used for antd modal
  // Added by - Ashlekh on 24-04-2025
  // Reason - This useEffect will execute when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Life Member List", path: "/life_member_list" },
    ]);
    window.scrollTo(0, 0);
    memberDetailsList(id);
  }, []);
  // End of code - Ashlekh on 24-04-2025
  // Reason - This useEffect will executes when page loads

  // Added by - Ashlekh on 24-04-2025
  // Reason - To get details from backend
  const memberDetailsList = async (id) => {
    try {
      const response = await getMemberDetailsListAPI(id);
      setMemberDetails(response?.member_details_ward_wise);
      setLifeMemberDetails(response?.life_member_details);
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 24-04-2025
  // Reason - To get details from backend

  // Added by - Ashlekh on 26-04-2025
  // Reason - To open/close antd modal
  const showModal = (member) => {
    setSelectedMember(member);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // End of code - Ashlekh on 26-04-2025
  // Reason - To open/close antd modal

  // Code changed by - Ashlekh on 02-06-2025
  // Reason - To hide registration number column if registration number is not present in every row
  const shouldShowRegistrationColumn = lifeMemberDetails?.some(
    (item) =>
      item.registration_number && item.registration_number.trim().length > 0
  );
  // End of code - Ashlekh on 02-06-2025
  // Reason - To hide registration number column if registration number is not present in every row

 // Added By: Yogen on 16-06-2025
 // Reason - To accurately check if CKEditor content is truly empty 
  function isEditorContentEmpty(htmlString) {
  const div = document.createElement("div");
  div.innerHTML = htmlString;
  const text = div.textContent || div.innerText || "";
  return text.trim().length === 0;
}
 // End of code - Yogen on 16-06-2025
 // Reason - To accurately check if CKEditor content is truly empty 

  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          <NavigationPath navigationPathArray={navigationPath} />
          <div className={`${style.pageTitle}`}>{ward_name}</div>
          {lifeMemberDetails?.length > 0 ? (
            <div>
              {/* Added by - Yogen on 12-06-2025
                  Reason - To display ward name as header */}
              {/* End of code - Yogen on 12-06-2025 
                  Reason -  To display ward name as header */}
              <div className={`${style.memberDetailsTable}`}>
                <table className={`${style.tableHeading}`}>
                  <thead>
                    <tr>
                      <th className={`${style.tableHeader} ${style.serialNo}`}>
                        S.No.
                      </th>
                      {/* Code changed by - Ashlekh on 02-06-2025
                      Reason - To hide registration number column if registration number is not present in every row */}
                      {shouldShowRegistrationColumn && (
                        <th
                          className={`${style.tableHeader} ${style.registrationNumber}`}
                        >
                          Registration Number
                        </th>
                      )}
                      {/* End of code - Ashlekh on 02-06-2025
                      Reason - To hide registration number column if registration number is not present in every row */}
                      <th
                        className={`${style.tableHeader} ${style.nameHeading}`}
                      >
                        Name
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.address}`}
                      >
                        Address
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.contactNumberHeading}`}
                      >
                        Contact Number
                      </th>
                      <th
                        className={`${style.tableHeader} ${style.viewProfileHeading}`}
                      >
                        {/* View */}
                        Family Detail
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {lifeMemberDetails?.map((item, index) => (
                     <tr key={index}> 
                        {/* Code changed by - Ashlekh on 02-06-2025
                        Reason - To hide registration number column if registration number is not present in every row */}
                        {/* Added by - Yogen on 12-06-2025
                          Reason - To add serial number */}
                        <td className={`${style.tableCell} ${style.serialNo}`}>
                          {index + 1}
                        </td>
                        {/* End of code - Yogen on 12-06-2025 
                          Reason - To add serial number */}
                        {shouldShowRegistrationColumn && (
                          <td
                            className={`${style.tableCell} ${style.registrationNumber}`}
                          >
                            {item.registration_number &&
                            item.registration_number.trim().length > 0
                              ? item.registration_number
                              : "-"}
                          </td>
                         )} 
                        {/* End of code - Ashlekh on 02-06-2025
                        Reason - To hide registration number column if registration number is not present in every row */}
                        <td className={`${style.tableCell} ${style.nameData}`}>
                          {/* {item.name} */}
                          {item.name && item.name.trim().length > 0 ? item.name : "-"}
                        </td>
                        <td className={`${style.tableCell} ${style.nameData}`}>
                          {/* {item.address} */}
                          {item.address && item.address.trim().length > 0 ? item.address : "-"}
                        </td>
                        <td
                          className={`${style.tableCell} ${style.contactNumberData}`}
                        >
                          {/* {item.contact_number} */}
                          {item.contact_number && item.contact_number.trim().length > 0 ? item.contact_number : "-"}
                        </td>
                        <td className={`${style.tableCell}`}>
                          {/* Added by : Yogen on 16/06/2025 
                              Reason : To show cross eye if description does not exist   */}
                          {item.description &&
                          // item.description?.trim()?.length > 0 ? (
                          !isEditorContentEmpty(item.description) ? (
                            <FaEye
                              className={`${style.eyeIconContainer}`}
                              onClick={() => showModal(item)}
                              color="black"
                            />
                          ) : (
                            <FaEyeSlash
                              className={`${style.eyeIconContainer}`}
                              color="black"
                            />
                          )}
                          {/* Ended by : Yogen on 16/06/2025
                              Reason : To show cross eye if description does not exist   */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Modal
                  open={isModalVisible}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <div className={style.memberDetailsContainer}>
                      {parse(selectedMember?.description || "")}
                  </div>
                </Modal>
              </div>
            </div>
           ) : (
                       <p className={style.noDetailsAvailableText}>No details available</p>
                     )} 
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default LifeMemberDetails;
